import React, { useState } from 'react';

function CarFeatureList({ features }) {
  const [showModal, setShowModal] = useState(false);
  const previewCount = 6;

  const previewFeatures = features.slice(0, previewCount);
  const hasMore = features.length > previewCount;

  const handleBackgroundClick = (e) => {
    if (e.target.id === "modal-background") {
      setShowModal(false);
    }
  };

  return (
    <div style={{ marginTop: "2rem" }}>
      <h3>Features</h3>
      <ul style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", padding: 0 }}>
        {previewFeatures.map((f, i) => (
          <li key={i} style={{
            backgroundColor: "#f0f0f0", padding: "0.5rem 0.75rem",
            borderRadius: "20px", listStyle: "none", fontSize: "0.9rem"
          }}>{f}</li>
        ))}
        {hasMore && (
          <li style={{ listStyle: "none" }}>
            <button onClick={() => setShowModal(true)} style={{
              backgroundColor: "#0077cc", color: "#fff",
              border: "none", padding: "0.5rem 0.75rem",
              borderRadius: "20px", cursor: "pointer"
            }}>
              Show More
            </button>
          </li>
        )}
      </ul>

      {/* Modal */}
      {showModal && (
        <div
          id="modal-background"
          onClick={handleBackgroundClick}
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)", display: "flex",
            justifyContent: "center", alignItems: "center", zIndex: 1000
          }}
        >
          <div style={{
            backgroundColor: "#fff", padding: "2rem",
            borderRadius: "10px", maxWidth: "600px", width: "90%",
            maxHeight: "80vh", overflowY: "auto", position: "relative"
          }}>
            <button
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                top: "1rem",
                right: "1rem",
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                fontWeight: "bold",
                cursor: "pointer"
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 style={{ marginTop: 0 }}>All Features</h3>
            <ul style={{ columns: 2, padding: 0 }}>
              {features.map((f, i) => (
                <li key={i} style={{
                  listStyle: "none", marginBottom: "0.5rem"
                }}>{f}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default CarFeatureList;
